import { History } from 'history';
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { HotelsLeftSide } from '../hotels/HotelsLeftSide';
import { CMS, HotelBedCatalogData, HotelBedData } from '../shared/index';
import { getOnlyFromCacheHotelCategoryCatalog, getAjaxhelper, momentWrapper } from '../utils/index';
import { HotelSearchResultWithUrlReqKeyMainPanel } from 'src/hotels/HotelSearchResultWithUrlReqKeyMainPanel';
import { sendHotelAvailibilityRequest } from 'src/utils/req-available-helper';
import { KEY_DEFAULT_SEARCH_DEST_CODE } from 'src/core';
// import { sendHotelAvailibilityRequest } from 'src/utils/req-available-helper';
export interface IndexSegmentProps extends BaseComponentProps {
    // id: string | number;
    lang: string;
    currency: string;
    data: CMS.CmsHotelSegment;
    pageSize: number;
    history?: History | any;
    wishlistCount: (c: number) => any;
    /** 
     * filter awal untuk data
     */
    initialFilter: HotelBedData.SearchFilter;
    // responkey: string;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;

    /**
     * real time database ref
     */
    realtimeDb: firebase.database.Database;

    firestoreDb: firebase.firestore.Firestore;
    updateInternalFilter: (filter: HotelBedData.SearchFilter) => any;
    /**
     * firebase uuid
     */
    uuid: string;
    // responKey: string;
    newRequestAvailability: (dari: string) => any;
    firebaseApp: firebase.app.App;
    pageChange: (page: number, dari: string) => any;
    page: number;
}
export interface IndexSegmentState extends BaseComponentState {
    data: CMS.CmsHotelSegment;
    hotelDetail?: any;
    hotelCodes: number[];
    responKey?: string | any;
    currentFilter: HotelBedData.SearchFilter | any;
    requesting: boolean;
    error: boolean;
    filterRateChange: boolean;
    indexedCategoryData: { [id: string]: HotelBedCatalogData.Category };
    filterRate: {
        maxRate: number,
        minRate: number
    };
    errorMessage: string | any;
    version: number;
    leftPanelRequesting: string;
    panelState: 'NEW_REQ_AVAILABLE' | 'REQ_AVAILABLE_READY';

}

export class IndexSegment extends BaseComponent<IndexSegmentProps, IndexSegmentState> {

    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['lang', 'currency'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = ['hotels', 'page', 'error', 'errorMessage', 'requesting', 'panelState'];

    timeout: any = null;

    /**
     * panel sisi kiri
     */
    leftSidePanel: HotelsLeftSide;
    /**
     * Panel untuk list hotels
     */
    // hotelMainPanel: HotelsMainContentWithBulkData;
    hotelMainPanel: HotelSearchResultWithUrlReqKeyMainPanel;
    constructor(props: IndexSegmentProps) {
        super(props);
        this.state = {
            panelState: "NEW_REQ_AVAILABLE",
            data: props.data,
            hotelCodes: [],
            requesting: true,
            error: false,
            errorMessage: null,
            currentFilter: null,
            filterRateChange: false,
            filterRate: {
                maxRate: 100000000,
                minRate: 0
            },
            indexedCategoryData: getOnlyFromCacheHotelCategoryCatalog(),
            version: 0, leftPanelRequesting: 'request'
        };
    }

    shouldComponentUpdate(nextProps: IndexSegmentProps, nextState: IndexSegmentState): boolean {
        if (this.compareForShouldComponentUpdateStateOrProp(IndexSegment.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(IndexSegment.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        let reqFilter: any = this.props.initialFilter;
        if (!reqFilter) {
            reqFilter = {
                stay: {
                    checkIn: momentWrapper().add(1, 'days'), // moment(),
                    checkOut: momentWrapper().add(3, 'days'), // moment().add(1 , 'days')
                },
                occupancies: [{ "rooms": "1", "adults": "2", "children": "0" }],
                destination: {
                    code: window[KEY_DEFAULT_SEARCH_DEST_CODE]
                }

            };
        }
        let dt1 = reqFilter!.stay!.checkIn;
        let dt2 = reqFilter!.stay!.checkOut;

        if (reqFilter.destination!.id) {
            delete reqFilter.destination!.id;
        }

        if (!reqFilter.destination!.zone || reqFilter.destination!.zone === 0) {
            delete reqFilter.destination!.zone;
        }

        if (typeof dt1 === 'string') {
            dt1 = momentWrapper(dt1);
        }
        if (typeof dt2 === 'string') {
            dt2 = momentWrapper(dt2);
        }

        reqFilter!.stay!.checkIn = dt1.format('YYYY-MM-DD');
        reqFilter!.stay!.checkOut = dt2.format('YYYY-MM-DD');

        reqFilter.boards = {
            included: true,
            board: ["RO", "BB"]
        };

        let filter: any = !reqFilter ? {} : reqFilter;

        if (filter && filter.hotels && filter.hotels.hotel && filter.hotels.hotel.length === 0) {
            filter.hotels.hotel = [];
        }

        getAjaxhelper().post(`/dynamics/hb-api/cms-segments`, { code: this.props.data.code, filter: filter }).then(
            (data) => {
                let filters: any = data.filter;
                this.setStateHelper(
                    st => {
                        st.currentFilter = filters;
                        st.hotelCodes = filters.hotels.hotel;
                    },
                    () => {
                        let x = this.state.currentFilter;
                        sendHotelAvailibilityRequest({ filter: x, app: this.props.firebaseApp }).then(d2 => {
                            this.setStateHelper(st2 => {
                                window["responKey"] = d2.responKey;
                                st2.responKey = d2.responKey;
                                st2.panelState = 'REQ_AVAILABLE_READY';
                            });
                        });
                    });

            }).catch(exc => {
                console.log(exc);

            });
    }

    render() {
        const props = this.props;
        const state = this.state;
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }

        if (this.state.panelState === 'REQ_AVAILABLE_READY') {
            return (
                <div>
                    <div style={{background: "url(https://storage.googleapis.com/bali-hotel-images/Banner-2.jpg)", backgroundPosition: 'center', backgroundSize: 'cover' }}>
                        <div className="container" style={{  paddingTop: 130, marginBottom: '-120px', height: 420}}>
                        <img style={{maxWidth: '100%'}} src="https://storage.googleapis.com/bali-hotel-images/Banner-offer.png"/>
                        </div>
                        
                    </div>
                    
                    <HotelSearchResultWithUrlReqKeyMainPanel
                        ref={d => { this.hotelMainPanel = d as any; window["hotelMainPanel"] = d; console.log("Simpan hotelMainPanel", this.hotelMainPanel); }}
                        responKey={this.state.responKey}
                        currency={props.currency}
                        history={props.history}
                        lang={this.props.lang}
                        initialFilter={state.currentFilter}
                        getHotels={this.props.getHotels}
                        pageSize={15}
                        newRequestAvailability={props.newRequestAvailability}
                        realtimeDb={props.realtimeDb}
                        firestoreDb={props.firestoreDb}
                        updateInternalFilter={props.updateInternalFilter}
                        wishlistCount={this.wishlistCount}
                        uuid={props.uuid}
                        fromSlug="segments"
                        slugData={this.state.data.code + ''}
                        firebaseApp={this.props.firebaseApp}
                        pageChange={this.props.pageChange}
                        page={this.props.page}
                    />
                </div>

            );
        }
        console.log("hotelMainPanel Di ht Segmen", this.hotelMainPanel);
        return <span>TDADADA</span>;
    }
    wishlistCount: (n: any) => any = n => {
        //
    }
}



// WEBPACK FOOTER //
// ./src/cms/IndexSegment.tsx